import { render, staticRenderFns } from "./management.cattle.io.project.vue?vue&type=template&id=1233d76b&"
import script from "./management.cattle.io.project.vue?vue&type=script&lang=js&"
export * from "./management.cattle.io.project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports